import React, { useState } from 'react'
import Skeleton from '@mui/material/Skeleton';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import Save from '../../Assets/images/save.svg'
import Progress from '../Home/Progress';
import { Link } from 'react-router-dom';
import Constant from '../../Constant';
import postService from '../../Services/post-service';
import { toast } from 'react-toastify';
import Loading from '../SelectValue/Loading';

function InvestCom({ name, state, per, img, percentage, target, raised, link, id, componentLoading }) {
  const [loading, setLoading] = useState(false)

  if (componentLoading) {
    return (
      <div className=' p-2  border-gray-200 shadow rounded-lg '>
        <div>
          <Skeleton variant="rectangular" width="100%" height={192} sx={{ mb: 2 }} />
          <div className=' flex justify-between mt-3 mb-3 '>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </div>
          <div className=' mb-4'>
            <Skeleton variant="text" width="40%" height={20} />
          </div>
          <div>
            <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={10} sx={{ borderRadius: 1, mb: 2 }} />
            <div className=' mb-4 flex justify-between'>
              <Skeleton variant="text" width="20%" height={14} />
              <Skeleton variant="text" width="20%" height={14} />
            </div>
            <div className=' mb-2 flex justify-between'>
              <Skeleton variant="text" width="40%" height={20} />
              <Skeleton variant="text" width="40%" height={20} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <div className=' p-2  border-gray-200 shadow rounded-lg '>
      <Loading
        open={loading}
      />
      <div>
        <Link to={link}>
          <img src={img} className=' w-full h-48' alt='' />
        </Link>
        <div className=' flex justify-between mt-3 mb-3 '>
          <p className=' text-back-color2 font-[500] text-[16px]  capitalize '>{name}</p>
          <img src={Save} onClick={handleSubmit} className=' inline-block cursor-pointer' alt='save' />
        </div>
        <Link to={link}>
          <div className=' mb-4'>
            <PlaceOutlinedIcon className='text-primary-color6' /> <p className=' text-[#44474E] inline-block pl-1'>{state}</p>
          </div>
          <div>
            <p className=' pb-2'>{per}% sold</p>
            <Progress value={percentage} />
            <div className=' mb-4 flex justify-between'>
              <p className='text-primary-color6'>Target</p>
              <p className='text-primary-color6'>Raised</p>
            </div>
            <div className=' mb-2 flex justify-between'>
              <p>NGN {Constant.FormatNumber(target)}</p>
              <p className=' text-primary-color'>NGN {Constant.FormatNumber(raised)}</p>
            </div>
          </div>
        </Link>
      </div>

    </div>
  )
}

export default InvestCom